import React, { useMemo } from 'react';
import { NavDropdown } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

import type { INavItem, INavItemProps } from '@/types/navigation';

import { getSubMenuNavItems } from '@/helpers/navigation';
import { useAppSelector } from '@/hooks';
import { featureFlags } from '@/store/slices/featureFlags/featureFlagsSlice';
import routes from '@/config/routes';

const DropdownItem = ({ item, menuType, onCollapseNavItem }: INavItemProps): React.ReactElement => {
  const featureFlag = useAppSelector(featureFlags);
  const subMenuItems = useMemo<INavItem[]>(() => {
    const reponse = getSubMenuNavItems(item.text, menuType);
    let indexToRemove = -1;
    reponse.forEach((menu, index) => {
      if (menu.to === routes.admin.agents.esignDocuments) {
        if (!featureFlag?.esignDocumentsEnabled) indexToRemove = index;
      }
    });
    if (indexToRemove !== -1) {
      reponse.splice(indexToRemove, 1);
    }
    return reponse;
  }, [item.text, menuType, featureFlag]);

  return (
    <NavDropdown title={item.text} id={item.to.toString()} key={item.to.toString()} onSelect={onCollapseNavItem}>
      {subMenuItems.map((subItem: INavItem) => (
        <NavDropdown.Item
          key={subItem.to.toString()}
          as={NavLink}
          to={subItem.to.toString()}
          {...(subItem.target && { target: subItem.target })}
        >
          <div style={{ marginLeft: 10 }}>{subItem.text}</div>
        </NavDropdown.Item>
      ))}
    </NavDropdown>
  );
};

export { DropdownItem };
